import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const languages = [
    { code: "en", label: "English" },
    { code: "ar", label: "العربية" },
    { code: "he", label: "עברית" },
  ];

  const handleChange = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <Select value={i18n.language} onValueChange={handleChange}>
      <SelectTrigger className="border w-36 border-primary bg-primary-light hover:bg-primary-light/80 rounded-full flex items-center gap-2 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-0 cursor-pointer">
        <div className="flex items-center gap-2">
          <Globe className="w-4 h-4 text-primary" />
          <SelectValue placeholder="Select language" />
        </div>
      </SelectTrigger>
      <SelectContent className="bg-white border rounded-lg shadow-lg z-50 min-w-[100px] sm:min-w-[120px]">
        {languages.map((lang) => (
          <SelectItem
            key={lang.code}
            value={lang.code}
            className="hover:bg-primary-light hover:text-primary cursor-pointer"
          >
            {lang.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
